import { useCallback } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { InputPasswordFieldNew } from "@/components/ui/form/fields-new/input-field/input-password";

import type { ChangeEvent } from "react";

type Props = {
	airHostAPIAccessToken: SiteControllerSettingAirHostFormModel["ViewModel"]["airHostSettings"]["airHostAPIAccessToken"];
	onSetAirHostAPIAccessToken: SiteControllerSettingAirHostFormModelMethodsType["onSetAirHostAPIAccessToken"];
};

export const SettingsSiteControllerAirHostAPIAccessToken = ({
	airHostAPIAccessToken,
	onSetAirHostAPIAccessToken,
}: Props) => {
	const handleChangeAPIAccessToken = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			onSetAirHostAPIAccessToken(event.target.value);
		},
		[onSetAirHostAPIAccessToken],
	);

	return (
		<QuestionForMain
			required={true}
			title={"アクセストークン（X-Access-Token）"}
			inputChildren={
				<InputPasswordFieldNew
					className="w-2/3 lg:w-1/2"
					value={airHostAPIAccessToken.value}
					errorMessage={airHostAPIAccessToken.error}
					onChange={handleChangeAPIAccessToken}
					autoComplete="off"
				/>
			}
		/>
	);
};

SettingsSiteControllerAirHostAPIAccessToken.displayName = "SettingsSiteControllerAirHostAPIAccessToken";
